export default __webpack_public_path__ + "static/media/Gallery - Edition II vs IV - 1_01.4072e904.jpg";